"use strict";

(function() {
    
    window.addEventListener('DOMContentLoaded',function(e) {

        if(Object.keys(window.delivery_route.modules).length > 0){
            // Delivery route
            import(window.delivery_route.modules.DeliveryRoute).then( moduleObj => {
                let DeliveryRoute = new moduleObj.default();
                DeliveryRoute.init();
            }).catch( err => console.log(err))
        }
        
    });
})();


